import {
  AddressBox,
  AddAddressModal,
  EditAddressModal,
  EmptyResult,
} from "../components";
import { DeleteCustomerAddress, GetSavedAddresses } from "../services";
import { useEffect, useState } from "react";
import { CustomerAddressModel } from "../models";
import { useAuth, useStore } from "../hooks";
import { useNavigate } from "react-router-dom";
import { Layout } from "../layouts";
import Skeleton from "react-loading-skeleton";
import { isEmpty } from "../helpers";
import { Toast } from "../components/Toast";

const AddressPage = () => {
  let navigate = useNavigate();

  const { storeId } = useStore();
  const { isLoggedIn, isGuest, customerId } = useAuth();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [addresses, setAddresses] = useState<CustomerAddressModel[]>([]);
  const [selectedAddress, setSelectedAddress] =
    useState<CustomerAddressModel>();
  const [showAddAddressModal, setShowAddAddressModal] =
    useState<boolean>(false);
  const [showEditAddressModal, setShowEditAddressModal] =
    useState<boolean>(false);

  useEffect(() => {
    if (!isLoggedIn || isGuest) navigate("/login");
    else fetchData();
  }, [isLoggedIn, isGuest]);

  async function fetchData() {
    try {
      setIsLoading(true);
      const { status, data } = await GetSavedAddresses({
        customer_id: customerId,
        address_type: "901",
      });
      if (status) setAddresses(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const handleEdit = (id: number | string) => {
    setSelectedAddress(addresses.find((item) => item.id === id));
    setShowEditAddressModal(true);
  };

  const handleStore = (address: CustomerAddressModel) => {
    setAddresses([...addresses, address]);
    setShowAddAddressModal(false);
  };

  const handleUpdate = (address: CustomerAddressModel) => {
    const updatedAddresses = addresses.map((item) =>
      item.id === address.id ? address : item,
    );

    setAddresses(updatedAddresses);
    setShowEditAddressModal(false);
  };

  const handleDelete = async (id: number | string) => {
    if (!confirm("Are you sure you want to delete this address?")) return false;

    const { status, message } = await DeleteCustomerAddress({
      store_id: storeId,
      customer_id: customerId,
      id: id,
    });

    if (status) {
      Toast.success(message);
      setAddresses(addresses.filter((item) => item.id !== id));
    } else Toast.error(message);
  };

  return (
    <Layout>
      <div className="choose_payment_method_main Profile_sec">

         <div className="payment_header d-flex justify-content-between align-items-start button_meel_bottom mb-3">
          <div>
          <h2 className="page-heading mb-1">Address</h2>
            <p className="mb-0 page-desc">Manage your Delivery Addresses.</p>
          </div>

          <button
            className="button"
            onClick={() => setShowAddAddressModal(true)}
          >
            + Add Address
          </button>
        </div>

        
        {isLoading && <Skeleton count={4} height={80} className="mb-3" />}
        {!isLoading && isEmpty(addresses) && (
          <EmptyResult message="No saved address found" />
        )}

        {addresses.map((address: CustomerAddressModel) => (
          <AddressBox
            key={address.id}
            address={address}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
          />
        ))}

        <button
          onClick={() => setShowAddAddressModal(true)}
          className="addnew_btn"
        >
          Add New
        </button>
      </div>

      <AddAddressModal
        show={showAddAddressModal}
        handleSuccess={handleStore}
        handleClose={() => setShowAddAddressModal(false)}
      />
      {selectedAddress && (
        <EditAddressModal
          show={showEditAddressModal}
          address={selectedAddress}
          handleSuccess={handleUpdate}
          handleClose={() => setShowEditAddressModal(false)}
        />
      )}
    </Layout>
  );
};

export default AddressPage;
